import { createSlice } from '@reduxjs/toolkit';
// import { fetchHallRoles } from './actions';

const initialState = {
  list: [],
  pagination: null,
  isLoading: false,
  error: null,
};

export const rolesSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {
    // Unused: nothing dispatches these helpers.
    // clearRolesError: (state) => {
    //   state.error = null;
    // },
    // resetRolesState: () => initialState,
  },
  // Unused: fetchHallRoles is never dispatched; roles come from pageProps.rolelist.
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(fetchHallRoles.pending, (state) => {
  //       state.isLoading = true;
  //       state.error = null;
  //     })
  //     .addCase(fetchHallRoles.fulfilled, (state, action) => {
  //       state.isLoading = false;

  //       const payload = action.payload;
  //       const data =
  //         payload?.data ?? payload?.results ?? payload?.items ?? payload ?? [];

  //       state.list = Array.isArray(data) ? data : [];
  //       state.pagination = payload?.pagination ?? payload?.meta ?? null;
  //     })
  //     .addCase(fetchHallRoles.rejected, (state, action) => {
  //       state.isLoading = false;
  //       state.error =
  //         action.payload || action.error?.message || 'Failed to fetch hall roles';
  //     });
  // },
});

// export const { clearRolesError, resetRolesState } = rolesSlice.actions;
export default rolesSlice.reducer;
